import { createContext } from "react";

const HeaderHeightContext = createContext();

export default HeaderHeightContext;